import ScreenContainer from "./ScreenContainer"

const Search = () => {
  return(
    <ScreenContainer>
      <h1>
        Search Screen
      </h1>
    </ScreenContainer>
  )
}

export default Search
